module.exports = __webpack_public_path__ + "img/sri_lanka_icc.4c12f358.png";